import { createAsyncThunk } from '@reduxjs/toolkit';
import * as myLearningService from './my-learning-card-api';

export const getPendingAssignment = createAsyncThunk(
    'myLearning/getAllAssignments',
    async ({ assignmentId }: { assignmentId?: number }) => {
        const response = await myLearningService.getPendingAssignment(
            assignmentId
        );
        return { ...response.data };
    }
);

export const getAllUserAssignmentCoursesById = createAsyncThunk(
    'myLearning/getAllUserAssignmentCoursesById',
    async (
        {
            userId,
            clientId,
            userAssignmentId,
            isAutoAssigned,
        }: {
            userId: number;
            clientId: number;
            userAssignmentId: number;
            isAutoAssigned?: boolean;
        },
        { rejectWithValue }
    ) => {
        try {
            const response =
                await myLearningService.getAllUserAssignmentCoursesById(
                    userId,
                    clientId,
                    userAssignmentId,
                    isAutoAssigned
                );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);
